import { Navigate, useLocation } from "react-router-dom";
import { isEmpty } from "lodash";
import { decodeToken } from "../Utils/jwt";

export const ProtectedRoute = ({ children }) => {
  const user = decodeToken(localStorage.getItem("token")) || {};
  let location = useLocation();
  if (!isEmpty(user)) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
};
export const ProtectedRouteLogin = ({ children }) => {
  const user = decodeToken(localStorage.getItem("token")) || {};
  let location = useLocation();
  if (isEmpty(user)) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
};
